import { Text } from '@kanda-libs/ks-design-library';
import type { Job } from '@kanda-libs/ks-frontend-services';

import Container from './LineItems-container';

import LineItem from '../../../LineItem';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  job?: Job;
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ job, isLoading }: ViewComponentProps) => (
  <Container job={job} isLoading={isLoading}>
    {({ lineItems }) => (
      <>
        <Text text="The job" className="block md:hidden text-16-20-em mb-3" />
        <div className="flex flex-col">
          {lineItems.map(({ key, ...item }) => (
            <LineItem
              key={key}
              item={item}
              isLoading={isLoading}
              variant="customer-job-view"
            />
          ))}
        </div>
      </>
    )}
  </Container>
);

ViewComponent.displayName = 'JobSidebar-LineItems-view';

ViewComponent.defaultProps = {
  job: undefined,
  isLoading: false,
};

export default ViewComponent;
